import { Component, OnInit } from '@angular/core';
import { APIService } from 'src/app/shared/service/apiService.service';

@Component({
    selector: 'app-user-active',
    templateUrl: './user-active.component.html',
    styleUrls: ['./user-active.component.scss']
})
export class UserActiveComponent implements OnInit {

    public user_list = [];

    constructor(private apiService: APIService) { }

    ngOnInit() {
        this.getUsers();
    }

    getUsers() {
        this.apiService.getAll().subscribe(
            (res: any) => {
                if (res && res.List) {
                    this.user_list = res.List;
                }
            },
            (err) => {
                console.error("Error fetching users", err);
            }
        );
    }

}
